import React from 'react'
import { Button, Dropdown, Row, Col } from 'antd';


function DefaultLayout(props) {
  const userData = JSON.parse(localStorage.getItem('user'));
  const user = userData?.user || userData;


  const items = [
    {
      key: '1',
      label: <a href="/home">Home</a>,
    },
    // Show "Bookings" only to regular users (not admin)
    ...(user && user.role !== 'admin' ? [{
      key: '2',
      label: <a href="/userbookings">Bookings</a>,
    }] : []),

    // Admin-only items
    ...(user?.role === 'admin' ? [
      {
        key: '3',
        label: <a href="/admin">Admin</a>,
      },
      {
        key: '4',
        label: <a href="/admin/bookings">All Bookings</a>,
      },
      {
        key: '5',
        label: <a href="/admin/abandoned">Abandoned Bookings</a>
      }
    ] : []),

    {
      key: '6',
      label: (
        <span onClick={() => {
          localStorage.removeItem('user');
          window.location.href = '/login';
        }}>
          Logout
        </span>
      ),
    },
  ];


  return (
    <div>
      <div className='header bs1'>
        <Row gutter={16} justify='center'>
          <Col lg={20} sm={24} xs={24}>

            <div className='d-flex justify-content-between'>
              <h1 ><b><a
                href="https://www.luxurylifelimo.com/limo"
                style={{ color: 'teal', textDecoration: 'none' }}
                target="_blank"
                rel="noopener noreferrer"
              >
                LuxuryLife Limo Services
              </a></b></h1>
              <Dropdown menu={{ items }} placement="bottom">
                <Button>{user.username}</Button>
              </Dropdown>
            </div>
          </Col>
        </Row>


      </div>
      <div className='content'>
        {props.children}

      </div>
    </div>
  )
}

export default DefaultLayout
